import React from 'react';
import { useTranslation } from 'react-i18next';
import { BUSINESS_TYPE, STEEL_MAKER } from '../../../constants';
import type { BusinessType, SteelMaker } from '../../../types/common';
import type { ConditionDetailType } from '../../../types/condition';

interface TableCustomizeProps {
  steelMaker: SteelMaker;
  businessType: BusinessType;
  detailCustomize: ConditionDetailType[];
}

const TableCustomize = ({ steelMaker, businessType, detailCustomize }: TableCustomizeProps): React.ReactElement => {
  const { t } = useTranslation();
  const isNsc: boolean = steelMaker === STEEL_MAKER.NIPPONSTEEL;
  const isDomesticAichi: boolean = businessType === BUSINESS_TYPE.DOMESTIC && steelMaker === STEEL_MAKER.AICHISTEEL;
  const isDomesticNsc: boolean = businessType === BUSINESS_TYPE.DOMESTIC && steelMaker === STEEL_MAKER.NIPPONSTEEL;

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <p className="mb-1">{t('condition.detailControl')}</p>
      <table className="table table-condition-detail">
        <thead>
          <tr>
            <th style={{ width: '16.6%' }}>{t('condition.customer1')}</th>
            {isNsc && (
              <>
                <th style={{ width: '16.6%' }}>{t('condition.customer2')}</th>
              </>
            )}
            {isDomesticNsc && (
              <>
                <th style={{ width: '16.6%' }}>{t('condition.customer3')}</th>
              </>
            )}
            {(isDomesticNsc || isDomesticAichi) && (
              <>
                <th style={{ width: '16.6%' }}>{t('deliveryLocation.deliveryLocation')}</th>
              </>
            )}
            <th style={{ width: '16.6%' }}>{t('millSheet.standard')}</th>
            <th style={{ width: '16.6%' }}>{t('millSheet.size')}</th>
          </tr>
        </thead>
        {detailCustomize.map((detail, index) => {
          return (
            <tbody key={'detailCustomize' + index}>
              <tr>
                <td>{detail.customer1}</td>
                {isNsc && (
                  <>
                    <td>{detail.customer2}</td>
                  </>
                )}
                {isDomesticNsc && (
                  <>
                    <td>{detail.customer3}</td>
                  </>
                )}
                {(isDomesticNsc || isDomesticAichi) && (
                  <>
                    <td>{detail.deliveryLocation}</td>
                  </>
                )}
                <td>{detail.standard}</td>
                <td>{detail.sizeDisplay}</td>
              </tr>
              <tr>
                <td>{detail.customer1Name ?? '\u00A0'}</td>
                {isNsc && (
                  <>
                    <td>{detail.customer2Name ?? '\u00A0'}</td>
                  </>
                )}
                {isDomesticNsc && (
                  <>
                    <td>{detail.customer3Name ?? '\u00A0'}</td>
                  </>
                )}
                {(isDomesticNsc || isDomesticAichi) && (
                  <>
                    <td>{detail.deliveryLocationName ?? '\u00A0'}</td>
                  </>
                )}
                <td>{'\u00A0'}</td>
                <td>{'\u00A0'}</td>
              </tr>
            </tbody>
          );
        })}
      </table>
    </>
  );
};

export default TableCustomize;
